import type { PropsWithChildren } from 'react';

import { Button } from '@change/ds-core-ui';

type Props = {
	to: string;
	buttonName: string;
};

export function ActionButton({ to, buttonName, children }: PropsWithChildren<Props>) {
	return (
		<div className="bg-fill-inverse-strong sticky bottom-0 z-20000 w-full px-4 py-2 md:static md:mb-[52px] md:bg-transparent md:px-0 md:py-0">
			<Button
				className="w-full md:w-auto"
				variant="primary"
				as="a"
				href={to}
				data-qa={`${buttonName}-button`}
				size="large"
			>
				{children}
			</Button>
		</div>
	);
}
